export default "__VITE_ASSET__B36iC9Kn__"